import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "react-router-dom";
import { browserRouter } from "./routing/page-routes";
import { DefaultAuthenticationProvider } from "./components/auth/DefaultAuthenticationProvider";
import { ToastContainer } from "react-toastify";
import * as Sentry from "@sentry/react";
import { ErrorBoundary } from "react-error-boundary";
import { ErrorFallback } from "./pages/error.page";

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      gcTime: 10 * 60 * 1000, // 10 minutes
      retry: 2,
    },
  },
});

export default function App() {
  return (
    <ErrorBoundary
      FallbackComponent={ErrorFallback}
      onError={(error) => {
        Sentry.captureException(error);
      }}
    >
      <QueryClientProvider client={queryClient}>
        <DefaultAuthenticationProvider>
          <ToastContainer />
          <RouterProvider router={browserRouter} />
        </DefaultAuthenticationProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  );
}
